import React from 'react';
import PropTypes from 'prop-types';

export default class SelectOption extends React.PureComponent {
    static propTypes = {
        /** The option value */
        value: PropTypes.string.isRequired,

        /** The option label/contents */
        children: PropTypes.node.isRequired,

        /** Disables the option */
        isDisabled: PropTypes.bool,
    };

    static defaultProps = {
        isDisabled: false,
    };

    render() {
        const { value, children, isDisabled } = this.props;

        return (
            <option value={value} disabled={isDisabled}>
                {children}
            </option>
        );
    }
}
